export default __webpack_public_path__ + "static/media/open-jobs-user-active.b4190ab0.svg";